import { useAuth } from '../lib/useAuth';
import { Button } from '../components/Button';

export function NotAdminPage() {
  const { user, signOut } = useAuth();
  return (
    <div className="center-screen">
      <div className="card auth-card">
        <h1 style={{ fontSize: 24, marginBottom: 8 }}>This account isn't an admin</h1>
        <p className="muted" style={{ marginBottom: 20 }}>
          {user?.email} is signed in but has no admin access to this site. Ask an existing admin to add it from the
          Admins page.
        </p>
        <Button tone="neutral" style={{ width: '100%' }} onClick={() => signOut()}>
          Sign out
        </Button>
      </div>
    </div>
  );
}
